import { Injectable }               from '@angular/core';
import { Observable, Subject }      from 'rxjs';
import { distinctUntilChanged }     from 'rxjs/operators';
import { ScreenState }              from '../models/ScreenStateEnum';

const MOBILE_MAX_WIDTH = 425;  //Adjust as needed
const TABLET_MAX_WIDTH = 1024; //Adjust as needed

@Injectable()
export class ResizeService {

  get onResize$(): Observable<ScreenState> {
    return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
  }

  private resizeSubject: Subject<ScreenState>;

  constructor() {
    this.resizeSubject = new Subject();
  }

  onResize(payload) {
    this.resizeSubject.next(payload);
  }

  checkCurrentSize()
  {
    var screenWidth = window.innerWidth;
    return this.calcCurrentScreenState(screenWidth);
  }

  calcCurrentScreenState(screenWidth)
  {
    const mobile = screenWidth <= MOBILE_MAX_WIDTH;
    const tablet = screenWidth <= TABLET_MAX_WIDTH && screenWidth > MOBILE_MAX_WIDTH;
    var screenstate = {
      mobile,
      tablet,
      desktop: !mobile && !tablet,
    };
    return screenstate;
  }

}